import React, { useContext } from 'react';
import { UserContext } from '../lib/usercontext';
import MasterLayout from './layouts/masterlayout';
import CustomerLayout from './layouts/customerlayout';
import ClientLayout from './layouts/clientlayout'; // Import the client layout
import InfoCard from './common/info_card';
import {
  ListBulletIcon,
  TruckIcon,
  UserCircleIcon,
  ShoppingCartIcon,
  UserGroupIcon,
  MapIcon,
  DocumentTextIcon,
  BuildingOffice2Icon,
  QuestionMarkCircleIcon,
  ChartBarIcon,
  Cog6ToothIcon
} from '@heroicons/react/24/outline';

const Dashboard = () => {
  const { user } = useContext(UserContext);
  const role = user.userGroups ? user.userGroups[0] : 'Customer';

  const pageTitle = `Welcome ${user.name}`;

  const adminCards = (
    <>
      <InfoCard
        Icon={TruckIcon}
        title="Create A New Delivery"
        description="Create a new delivery for a client."
        linkText="Create Delivery"
        linkHref="/deliveries/create"
      />
      <InfoCard
        Icon={ListBulletIcon}
        title="Manage Deliveries"
        description="View and manage client deliveries."
        linkText="Manage Deliveries"
        linkHref="/deliveries"
      />
      <InfoCard
        Icon={ShoppingCartIcon}
        title="Manage Orders"
        description="View and manage client orders."
        linkText="Manage Orders"
        linkHref="/orders"
      />
      <InfoCard
        Icon={MapIcon}
        title="Routes"
        description="Plan and view delivery routes."
        linkText="View Routes"
        linkHref="/routes"
      />
      <InfoCard
        Icon={BuildingOffice2Icon}
        title="Manage Providers"
        description="View and manage Providers information."
        linkText="Manage Providers"
        linkHref="/Providers"
      />
      <InfoCard
        Icon={UserGroupIcon}
        title="Manage Clients"
        description="View and manage client information."
        linkText="Manage Clients"
        linkHref="/clients"
      />
      <InfoCard
        Icon={ChartBarIcon}
        title="View Reports"
        description="Access various system reports."
        linkText="View Reports"
        linkHref="/reports"
      />
      <InfoCard
        Icon={UserCircleIcon}
        title="Manage Users"
        description="View and manage user accounts."
        linkText="Manage Users"
        linkHref="/users"
      />
      <InfoCard
        Icon={QuestionMarkCircleIcon}
        title="Help"
        description="Access help and support resources."
        linkText="Get Help"
        linkHref="/help"
      />
    </>
  );

  const customerCards = (
    <>
      <InfoCard
        Icon={ShoppingCartIcon}
        title="Create New Order"
        description="Start a new order."
        linkText="Create Order"
        linkHref="/orders/create"
      />
      <InfoCard
        Icon={ListBulletIcon}
        title="Order History"
        description="View your past orders."
        linkText="Order History"
        linkHref="/orders"
      />
      <InfoCard
        Icon={Cog6ToothIcon}
        title="Set Default Order"
        description="Set your default order preferences."
        linkText="Set Default Order"
        linkHref="/orders/default"
      />
    </>
  );

  const clientCards = (
    <>
      <InfoCard
        Icon={ShoppingCartIcon}
        title="Manage Orders"
        description="View and manage customer orders."
        linkText="Manage Orders"
        linkHref="/orders"
      />
      <InfoCard
        Icon={UserGroupIcon}
        title="Manage Clients"
        description="View and manage client information."
        linkText="Manage Clients"
        linkHref="/clients"
      />
      <InfoCard
        Icon={DocumentTextIcon}
        title="Billing Summaries"
        description="View billing summaries."
        linkText="Billing Summaries"
        linkHref="/reports"
      />
      <InfoCard
        Icon={ChartBarIcon}
        title="View Reports"
        description="Access various system reports."
        linkText="View Reports"
        linkHref="/reports"
      />
    </>
  );

  return (
    <div>
      {role === 'Admin' ? (
        <MasterLayout pageTitle={pageTitle}>
          <div className="flex flex-wrap items-start gap-x-4 gap-y-4 p-4">
            {adminCards}
          </div>
        </MasterLayout>
      ) : role === 'Customer' ? (
        <CustomerLayout pageTitle={pageTitle}>
          <div className="flex flex-wrap items-start gap-x-4 gap-y-4 p-4">
            {customerCards}
          </div>
        </CustomerLayout>
      ) : (
        <ClientLayout pageTitle={pageTitle}>
          <div className="flex flex-wrap items-start gap-x-4 gap-y-4 p-4">
            {clientCards}
          </div>
        </ClientLayout>
      )}
    </div>
  );
}

export default Dashboard;
